/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * Represents 3rd party customer information related to billing for a company
 * @export
 * @interface BillingDetails
 */
export interface BillingDetails {
    /**
     * 
     * @type {number}
     * @memberof BillingDetails
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BillingDetails
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    name: string;
    /**
     * 
     * @type {Address}
     * @memberof BillingDetails
     */
    address: Address;
}

/**
 * Check if a given object implements the BillingDetails interface.
 */
export function instanceOfBillingDetails(value: object): value is BillingDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function BillingDetailsFromJSON(json: any): BillingDetails {
    return BillingDetailsFromJSONTyped(json, false);
}

export function BillingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'address': AddressFromJSON(json['address']),
    };
}

  export function BillingDetailsToJSON(json: any): BillingDetails {
      return BillingDetailsToJSONTyped(json, false);
  }

  export function BillingDetailsToJSONTyped(value?: BillingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'name': value['name'],
        'address': AddressToJSON(value['address']),
    };
}

